@if (bannerImage) {
  <img [src]="bannerImage" (error)="imageError()" alt="" />
}
<app-center-section>
  <h1>{{ title }}</h1>
  <div [innerHTML]="description | sanitizeHtml" class="page-description rich-text"></div>

  <form class="giftcard-form" [formGroup]="form">
    <mat-radio-group [formControl]="form.controls.type">
      <mat-radio-button [value]="0">GAVEKORT</mat-radio-button>
      <!-- <mat-radio-button [value]="1">KLIPPEKORT</mat-radio-button> -->
    </mat-radio-group>

    @let content = form.value.type === GiftCardType.Punch ? punchContent : giftContent;
    @if (form.value.type === GiftCardType.Punch) {
      <section class="card-settings">
        <div class="punches">
          <label for="punch-charges">Vælg hvor mange klip</label>
          <ng-select [formControl]="form.controls.charges" id="punch-charges">
            @for (number of [2, 3, 4, 5, 6, 7, 8, 9, 10]; track number) {
              <ng-option [value]="number">{{ number }}</ng-option>
            }
          </ng-select>
          <p
            [class.error]="
              form.value.charges && form.value.chargesAmount && form.value.charges * form.value.chargesAmount < minimumGiftCardAmount
            "
          >
            Samlet beløb: {{ form.value.charges * form.value.chargesAmount || '0' }} {{ currency | displayCurrency }}
          </p>
          @if (form.value.charges && form.value.chargesAmount && form.value.charges * form.value.chargesAmount < minimumGiftCardAmount) {
            <p class="error">samlet minimumskøb er {{ minimumGiftCardAmount }} {{ currency | displayCurrency }}</p>
          }
        </div>

        <div class="price">
          <app-text-input
            [control]="form.controls.chargesAmount"
            type="number"
            [name]="content.valueLabel"
            [placeholder]="content.valuePlaceholder"
          ></app-text-input>
          @if (content.valueClarification) {
            <p>
              {{ content.valueClarification }}
            </p>
          }
        </div>
      </section>
    }

    @if (form.value.type === GiftCardType.Gift) {
      <section class="card-settings">
        <div class="price">
          <app-text-input
            [control]="form.controls.value"
            type="number"
            [name]="content.valueLabel"
            [placeholder]="content.valuePlaceholder"
          ></app-text-input>
          @if (content.valueClarification) {
            <p>
              {{ content.valueClarification }}
            </p>
          }
        </div>
      </section>
    }

    <section class="recipient">
      <h2>{{ recipientTitle }}</h2>
      <app-text-input
        [control]="form.controls.recipientName"
        type="text"
        [name]="nameLabel"
        [placeholder]="namePlaceholder"
      ></app-text-input>
      <app-text-input
        [control]="form.controls.recipientEmail"
        type="text"
        [name]="content.emailLabel"
        [placeholder]="content.emailPlaceholder"
      ></app-text-input>
      <app-text-input
        class="message"
        [control]="form.controls.accompanyingMessage"
        type="text"
        [name]="content.accompanyingMessageLabel"
        [placeholder]="content.accompanyingMessagePlaceholder"
        [textarea]="true"
      ></app-text-input>
    </section>
  </form>

  <app-gift-card-delivery [title]="senderTitle" [form]="deliveryForm"></app-gift-card-delivery>

  <div class="card-price-overview">
    <h2>{{ overviewTitle }}</h2>
    <table>
      <thead>
        <tr>
          <td class="card-name">{{ overview.name }}</td>
          <td>{{ form.value.type === GiftCardType.Punch ? overview.pricePerPunch : overview.pricePerUnit }}</td>
          <td>
            @if (form.value.type === GiftCardType.Punch) {
              {{ overview.amount }}
            }
          </td>
          <td>{{ overview.totalPrice }}</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="card-name">Gavekort</td>
          @if (form.value.type === GiftCardType.Gift) {
            <td>{{ form.value.value >= minimumGiftCardAmount ? form.value.value + ' ' + currency : '' }}</td>
            <td></td>
            <td>{{ form.value.value >= minimumGiftCardAmount ? form.value.value + ' ' + currency : '' }}</td>
          }

          @if (form.value.type === GiftCardType.Punch) {
            <td>
              {{ form.value.chargesAmount * form.value.charges >= minimumGiftCardAmount ? form.value.chargesAmount + ' ' + currency : '' }}
            </td>
            <td>{{ form.value.chargesAmount * form.value.charges >= minimumGiftCardAmount ? form.value.charges : '' }}</td>
            <td>
              {{
                form.value.chargesAmount * form.value.charges >= minimumGiftCardAmount
                  ? form.value.chargesAmount * form.value.charges + ' ' + currency
                  : ''
              }}
            </td>
          }
        </tr>
        @if (shippingPrice) {
          <tr>
            <td>{{ overview.shippingPriceLabel }}</td>
            <td></td>
            <td></td>
            <td>{{ shippingPrice }} {{ currency | displayCurrency }}</td>
          </tr>
        }

        <tr>
          <td>{{ overview.VATLabel }}</td>
          <td></td>
          <td></td>
          @if (form.value.type === GiftCardType.Gift) {
            <td>
              @let vat = ((form.value.value >= minimumGiftCardAmount ? +form.value.value : 0) + shippingPrice) * 0.2;
              {{ vat }} {{ currency | displayCurrency }}
            </td>
          }

          @if (form.value.type === GiftCardType.Punch) {
            <td>
              @let vat =
                ((form.value.chargesAmount * form.value.charges >= minimumGiftCardAmount
                  ? +form.value.chargesAmount * +form.value.charges
                  : 0) +
                  shippingPrice) *
                0.2;
              {{ vat }}
              {{ ' ' + currency }}
            </td>
          }
        </tr>
      </tbody>
    </table>
    <div class="price-total">
      <label for="total-price">{{ overview.totalSummary }}</label>
      @if (form.value.type === GiftCardType.Gift) {
        <b id="total-price">
          @let total = (form.value.value >= minimumGiftCardAmount ? +form.value.value : 0) + shippingPrice;
          {{ total }} {{ currency | displayCurrency }}
        </b>
      }

      @if (form.value.type === GiftCardType.Punch) {
        <b id="total-price">
          @let total =
            (form.value.chargesAmount * form.value.charges >= minimumGiftCardAmount ? +form.value.chargesAmount * form.value.charges : 0) +
            shippingPrice;
          {{ total }}
          {{ ' ' + currency }}
        </b>
      }
    </div>
  </div>

  <div class="options">
    <div class="terms">
      <app-toggle [control]="deliveryForm.controls.tradeAgreement"></app-toggle>
      <span>
        {{ termsOfServiceLabel }}<br /><a [routerLink]="tradeCondtionsLink" target="_blank">{{ termsOfServiceLinkLabel }}</a>
      </span>
    </div>
    <div class="checkout">
      <app-payment-options for="checkout"></app-payment-options>
      <app-text-button (click)="checkoutGiftCard()">{{ addToBasketButton }}</app-text-button>
    </div>
  </div>
</app-center-section>
